
import Typography from '@/ui-kit/components/typography';
import Icon from '@/ui-kit/components/icon';
import Gutter from '@/ui-kit/components/gutter';
import Button from '@/ui-kit/components/button';
import { ButtonProperty, ButtonPropsEventType } from '@/ui-kit/components/button/enums';
import { GutterProperty } from '@/ui-kit/components/gutter/enums';
import { TypographyType, TypographyProperty } from '@/ui-kit/components/typography/enums';
import {
  StyleColorSchemeType,
  StylePositionType,
  StyleSizeType,
  StyleFontWeightType,
} from '@/ui-kit/styles/enums';
import { IconType, IconProperty } from '@/ui-kit/components/icon/enums';
import { SoldDataShareEvenType } from './enums';

export default {
  name: 'SoldDataShare',
  components: {
    Typography,
    Gutter,
    Button,
    Icon,
  },
  data() {
    return {
      TypographyType,
      TypographyProperty,
      StyleColorSchemeType,
      StylePositionType,
      StyleSizeType,
      StyleFontWeightType,
      ButtonProperty,
      ButtonPropsEventType,
      GutterProperty,
      IconType,
      IconProperty,
    };
  },
  methods: {
    handleShareButtonClick() {
      this.$emit(SoldDataShareEvenType.ShareSearch);
    },
  },
};
